// extracted by mini-css-extract-plugin
module.exports = {"footer":"PartnerFooterUI__footer___2bJvI","select-button":"PartnerFooterUI__select-button___3oHci"};